import { render, staticRenderFns } from "./SolanStudentViewMenuButton.vue?vue&type=template&id=3eaf05f8&scoped=true&"
import script from "./SolanStudentViewMenuButton.vue?vue&type=script&lang=ts&"
export * from "./SolanStudentViewMenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./SolanStudentViewMenuButton.vue?vue&type=style&index=0&id=3eaf05f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaf05f8",
  null
  
)

export default component.exports